import {Grid} from "@mui/material";
import PerformanceAnalysisPage from "../PerformanceAnalysis/PerformanceAnalysisPage";
import {GenerationEnergy} from "../GenerationEnergyChart/GenerationEnergy";
import YeldChartComparison from "../YieldChartComparison/YeldChartComparison";
import PRComparison from "../PRComparison/PRComparison";
import TicketWidget from "../Ticket/TicketWidget";
import { useAppSelector } from "../../../Config/Hooks";
import { hasPermission } from "../../../Shared/Auth/AuthenticationUtil";
import { AUTHORITIES } from "../../../Config/Constants";
import { ASectionTitle } from "@atiautomacao/ati-ui-library";

export default function DashboardOverviewChartsPage(){

    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToSearch = hasPermission(account?.authoritySet, [ AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_TICKET ]);
    return(
            <Grid container spacing={'24px'} paddingLeft={'24px'} paddingRight={'24px'} paddingBottom={'24px'}>
                <Grid item xs={12} style={{padding: '0 24px'}}>
                    <PerformanceAnalysisPage />
                </Grid>
                 <Grid item xs={12}>
                    <ASectionTitle
                       styleContainer={{ padding: '32px 24px 24px 0px' }}
                       titleLabel="Gráficos de Atividade"/>
                </Grid>
                <Grid item xs={12} style={{padding: 24, paddingTop:0}}>
                    <GenerationEnergy/>
                </Grid>
                <Grid item xs={12} lg={12} xl={5} style={{padding: 24}}>
                    <PRComparison />
                </Grid>
                <Grid item xs={12} lg={12} xl={7} style={{padding: 24}}>
                    <YeldChartComparison />
                </Grid>
                
                { isAuthorizedToSearch &&
                    <Grid item xs={12} style={{padding: 24}}>
                        <TicketWidget />
                    </Grid>
                }
            </Grid>
    );
}